// extracted by mini-css-extract-plugin
export default {"container":"Vba-z","creativeContainer":"Wba-z","copy":"Xba-z","cta":"Yba-z","disabled":"Zba-z","flipped":"_ba-z","productCard":"aca-z"};